import {
  useGetQuery,
  useLazyGetQuery,
  usePostMutation,
  usePutMutation,
  useDeleteMutation,
} from "slices/api";
import { UTILITY } from "tagTypes";

export const useUtilityQuery = (query = {}) =>
  useGetQuery({
    endpoint: "/utility",
    query,
    tags: [UTILITY],
  });

export const useLazyUtilityQuery = () => {
  const [getUtility, data] = useLazyGetQuery();
  const utility = async (query = {}) =>
    await getUtility(
      {
        endpoint: "/utility",
        query,
        tags: [UTILITY],
      },
      true
    ).unwrap();
  return [utility, data];
};

export const usePostUtilityMutation = () => {
  const [utility, data] = usePostMutation();
  const addUtility = async (payload, query = {}) =>
    await utility({
      endpoint: "/utility",
      query,
      payload: payload || {},
      toastMessage: "Utility added successfully",
      tags: [UTILITY],
    }).unwrap();
  return [addUtility, data];
};

export const usePutUtilityMutation = () => {
  const [utility, data] = usePutMutation();
  const updateUtility = async (payload, id, query = {}) =>
    await utility({
      endpoint: `/utility/${id}`,
      query,
      payload: payload || {},
      toastMessage: "Utility updated successfully",
      tags: [UTILITY],
    }).unwrap();
  return [updateUtility, data];
};

export const useDeleteUtilityMutation = () => {
  const [utility, data] = useDeleteMutation();
  const deleteUtility = async (id, query = {}) =>
    await utility({
      endpoint: `/utility/${id}`,
      query,
      toastMessage: "Utility deleted successully",
      tags: [UTILITY],
    }).unwrap();
  return [deleteUtility, data];
};
